module.exports = __webpack_public_path__ + "img/linkedin.747b6e3.svg";